module.exports = __webpack_public_path__ + "img/foreigner_men.4cb641ac.png";